import { connector } from "../../utils/common/connector";

const controller = "customerCategory";

// ---------------------------------------------
// GET CATEGORIES BY COMPANY
// ---------------------------------------------
export const getCustomerCategoriesService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(controller, "getCategoriesByCompany", params);
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

// ---------------------------------------------
// GET CATEGORIES BY PAGINATION
// ---------------------------------------------
export const getCustomerCategoriesByPaginationService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(
      controller,
      "getCategoriesByPagination",
      params,
    );
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

// ---------------------------------------------
// CREATE CUSTOMER CATEGORY
// ---------------------------------------------
export const createCustomerCategoryService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.post(controller, "newCategory", params);
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE CUSTOMER CATEGORY
// ---------------------------------------------
export const updateCustomerCategoryService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.post(controller, "updateCategory", params);
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};
